import { formatEnter } from '../utils'

const TooltipInfo = ({ active, payload, textos }) => {
	if (active) {
		return (
			<div className='custom-tooltip e6'>
				<header className='e7'>
					{textos.titol_tooltip} {formatEnter(payload[0].payload.maxim)}€
				</header>
				<p>
					{textos.sme_total}{' '}
					<span>{formatEnter(payload[0].payload.sme_total)}€</span>
				</p>
				<p>
					{textos.sme_dona}{' '}
					<span>{formatEnter(payload[0].payload.sme_dona)}€</span>
				</p>
				<p>
					{textos.sme_home}{' '}
					<span>{formatEnter(payload[0].payload.sme_home)}€</span>
				</p>
				<footer className='text-gris'>
					<span>{textos.percentil}:</span>
					<span>{String(payload[0].payload.centil).padStart(2, '0')}</span>
				</footer>
			</div>
		)
	}
	return null
}
export default TooltipInfo
